// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1vkNO","title":"InfoRow_title__3gPZj"};